"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const GlobalEvent_vue_1 = require("@/client/components/turmoil/GlobalEvent.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectGlobalEvent',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
            required: false,
            default: false,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: undefined,
        };
    },
    components: {
        GlobalEvent: GlobalEvent_vue_1.default,
        AppButton: AppButton_vue_1.default,
    },
    methods: {
        saveData() {
            if (this.selected === undefined) {
                throw new Error('Select a global event');
            }
            this.onsave({ type: 'globalEvent', globalEventName: this.selected });
        },
    },
});
